<template>
	<div>
		<div class="page">
			<div class="form-page">
				<img src="https://cobraticket.uy/logo.png" alt="" class="logo" />

				<div v-if="!loading && !error && !done">
					<div class="content">
						<h3>Ingresá tus datos para obtener una entrada de cortesía al evento {{ event.name }}</h3>

						<p>
							<!-- Promocione y venda entradas online para sus eventos de forma simple con CobraTicket -->
						</p>
						<form @submit.prevent="save" class="mt-4">
							<FormulateForm v-model="form" @submit="save()">
								<FormulateInput
									class="mt-3"
									name="name"
									type="text"
									label="Nombre"
									placeholder="Ingrese su nombre"
									validation="required"
								/>
								<FormulateInput
									class="mt-3"
									name="lastname"
									type="text"
									label="Apellido"
									placeholder="Ingrese su apellido"
									validation="required"
								/>
								<FormulateInput
									class="mt-3"
									name="email"
									type="email"
									label="Email"
									placeholder="Ingrese su email"
									validation="required|email"
								/>

								<FormulateInput
									type="date"
									name="birthdate"
									validation-name="Fecha de nacimiento"
									label="Fecha de nacimiento"
									validation="required"
									:splitted="true"
								/>

								<!-- <div class="alert alert-danger text-white mt-4" v-if="loginError">
											{{ errorMessage }}
										</div> -->

								<button class="btn btn-primary btn-block btn-lg mt-4" type="submit">
									<span v-if="saving">Enviando <span class="btn-loader"/></span>
									<span v-if="!saving">Confirmar </span>
								</button>
							</FormulateForm>
						</form>
					</div>
				</div>
				<div v-if="done" class="content">
					<h3>Entrada de cortesía generada</h3>
					<p>
						En breve recibirá un email con la entrada y el código QR que deberá mostrar en el acceso al
						evento.
					</p>
				</div>
				<div v-if="error" class="content">
					<h3>Ha ocurrido un error</h3>
					<p>
						{{ errorMessage }}
					</p>
				</div>
			</div>

			<div class="image" v-if="event && event.image" :style="`background-image:url(${event.image.url})`"></div>
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag"
import Loader from "@/components/Loader"

export default {
	name: "TicketCourtesyInvitationAccept",
	components: {
		Loader
	},
	data() {
		return {
			loading: true,
			saving: false,
			error: false,
			errorMessage: "",
			eventId: null,
			done: false,
			invitationCode: null,
			ticketTypeId: null,
			event: null,
			form: {
				name: "",
				lastname: "",
				email: "",
				birthdate: null
			}
		}
	},
	async beforeMount() {
		this.loading = true

		this.eventId = this.$route.params.eventId
		this.invitationCode = this.$route.params.invitationCode
		this.ticketTypeId = this.$route.params.ticketTypeId

		// busco si hay tickets de cortesia disponibles para esta conbinacion de evento - promotor - tipo de ticket.
		await this.hasAvailableTickets()
		this.event = await this.loadEvent()
		this.loading = false
	},
	methods: {
		async loadEvent() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							event(id: $id) {
								id
								name
								startAt
								endAt
								image {
									id
									type
									filename
									url
									urlThumb
								}
								status
								statusText
								statusClass
							}
						}
					`,
					variables: { id: this.eventId },
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					return data.event
				})
				.catch(() => {})
		},
		hasAvailableTickets() {
			return this.$apollo
				.query({
					query: gql`
						query($invitationCode: ID!, $ticketTypeId: ID!) {
							ticketCourtesyEventPromotorHasAvailability(
								invitationCode: $invitationCode
								ticketTypeId: $ticketTypeId
							)
						}
					`,
					variables: {
						invitationCode: this.invitationCode,
						ticketTypeId: this.ticketTypeId
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					if (data.ticketCourtesyEventPromotorHasAvailability) {
						return data.ticketCourtesyEventPromotorHasAvailability
					} else {
						this.error = true
						this.errorMessage =
							"El evento no tiene tickets de cortesía disponibles para este tipo de invitación."
					}
				})
		},
		async save() {
			if (!this.saving) {
				this.saving = true

				let dataHolder = {
					name: this.form.name,
					lastname: this.form.lastname,
					birthdate: this.form.birthdate,
					email: this.form.email
				}
				return this.$apollo
					.mutate({
						mutation: gql`
							mutation($invitationCode: ID!, $ticketTypeId: ID!, $holder: TicketCourtesyHolderInput!) {
								ticketCourtesyEventPromotorRequest(
									invitationCode: $invitationCode
									ticketTypeId: $ticketTypeId
									holder: $holder
								)
							}
						`,
						variables: {
							invitationCode: this.invitationCode,
							ticketTypeId: this.ticketTypeId,
							holder: dataHolder
						},
						fetchPolicy: "no-cache"
					})
					.then(({ data }) => {
						this.$toast.success("Ticket de cortesía enviado correctamente")
						this.saving = false
						this.done = true
						this.$emit("updated")
					})
					.catch((err) => {
						this.parseGQLErrors(err)
						this.saving = false
					})
			}
		}
	}
}
</script>

<style scoped lang="scss">
.page {
	display: flex;
	background-color: #fff;
}

.image {
	width: 100vh;
	height: 100vh;
	background-color: #333;
	background-size: cover;
	background-position: center center;
}

.form-page {
	padding: 32px;
	flex-grow: 1;

	min-width: 420px;

	height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	background: #fff;
	overflow-y: auto;

	.logo {
		display: block;
		width: 200px;
		margin-bottom: 96px;
	}

	.content {
		max-width: 400px;
	}
	h3 {
		font-size: 1.375rem;
		font-weight: 700;
		line-height: 1.3;
		margin: 0;
		margin-bottom: 12px;
	}
	p {
		font-size: 1rem;
	}
	.formulate-input {
		margin-bottom: 8px !important;
	}

	.btn {
		font-size: 16px;
		font-weight: 500;
		text-transform: uppercase;
	}
}

@media (max-width: 991px) {
	.image {
		display: none;
	}
	.form-page {
		width: 100%;
		min-width: 0;
		max-width: 100%;
	}
}

@media (max-width: 768px) {
}
</style>
